import { render, staticRenderFns } from "./MyPopover.vue?vue&type=template&id=04df7b30&"
import script from "./MyPopover.vue?vue&type=script&lang=js&"
export * from "./MyPopover.vue?vue&type=script&lang=js&"
import style0 from "./MyPopover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports